import Modal from 'components/modal'
import { Button } from 'components/common'

type Props = {
  isOpen: boolean
  closeModal: () => void
  onConfirm: any
  file: any
}

const ConfirmImportFileModal = ({
  isOpen,
  closeModal,
  onConfirm,
  file,
}: Props) => {
  // close the modal and untick the delete store checkbox
  const cancelImport = () => {
    closeModal()
  }

  return (
    <Modal
      width={550}
      title={`Confirm Import file?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={cancelImport}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <div>
          Are you sure you want to import{' '}
          <strong>{file && file[0]?.name} </strong>?
        </div>

        {/* Actions */}
        <div className="mt-6 flex  w-full items-center gap-5">
          <Button
            onClick={onConfirm}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelImport}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmImportFileModal
